import DropDownSelectFilter from './drop-down-select-filter.vue';

export default DropDownSelectFilter;



// WEBPACK FOOTER //
// ./src/FcComponents/drop-down-select-filter/index.js